module.exports = __webpack_public_path__ + "datacollect/static/img/logo8.ff80233.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo8.png
// module id = Z+VT
// module chunks = 1